export default "__VITE_ASSET__D3F$lQBC__";